(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["leoz-node-ui"] = factory();
	else
		root["leoz-node-ui"] = factory();
})(globalThis, () => {
return 